<template>
  <div class="divBox">
    <el-card class="box-card">
      <el-form
        ref="formValidate"
        v-loading="fullscreenLoading"
        class="formValidate mt20"
        label-width="160px"
        v-model="formValidate"
        @submit.native.prevent
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="品类名称：" prop="cate_name">
              <el-input v-model="formValidate.cate_name"  />
            </el-form-item>
          </el-col>
          <el-col :span="24" >
            <el-form-item label="图片：" prop="cate_image">
              <div
                class="upLoadPicBox"
                title="750*750px"
                @click="modalPicTap('1','cate_image')"
              >
                <div v-if="formValidate.cate_image" class="pictrue">
                  <img :src="formValidate.cate_image">
                </div>
                <div v-else class="upLoad">
                  <i class="el-icon-camera cameraIconfont" />
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传图片类型：">
              <el-table
                :data="data"
                border
                size="small"
                style="width: 100%"
              >
                <el-table-column align="center" prop="cate_value_name" label="标题" min-width="200">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.cate_value_name" class="priceBox"/>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="cate_value_img" label="图片" min-width="200">
                  <template slot-scope="scope">
                    <div
                      class="upLoadPicBox"
                      title="750*750px"
                      @click="modalPicTap('1','cate_value_img',scope.$index)"
                    >
                      <div v-if="scope.row.cate_value_img" class="pictrue">
                        <img :src="scope.row.cate_value_img">
                      </div>
                      <div v-else class="upLoad">
                        <i class="el-icon-camera cameraIconfont" />
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" min-width="120">
                  <template slot-scope="scope">
                    <el-button type="text" class="submission" @click="delSpecs(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="onAdd">添加参数</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="margin-top:30px;">
          <el-button :loading="loading" type="primary" class="submission" size="small" @click="handleSubmit()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from '@/settings'
import {
  appraisalCateDetailApi,
  appraisalPersonDetailApi,
  saveAppraisalCateDataApi,
  saveAppraisalPersonDataApi
} from "@/api/appraisal";
const defaultObj = {
  cate_name: '',
  cate_image: '',
  cate_value: [],
}
export default {
  name: 'addCate',
  data() {
    return {
      roterPre: roterPre,
      fullscreenLoading: false,
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      grid2: {
        xl: 10,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      progress: 0,
      data: [],
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getAppraisalCateData()
    }

  },
  methods: {
    onAdd() {
      if(!this.data)
      {
        this.data = [];
      }
      let obj = { cate_value_name: "", cate_value_img:""};
      this.data.push(obj);
    },
    // 删除
    delSpecs(idx) {
      this.data.splice(idx, 1);
    },
    // 点击图
    modalPicTap(tit,num,i) {
      const _this = this;
      const attr = [];
      this.$modalUpload(function(img) {
        if(num == 'cate_image')
        {
          _this.formValidate.cate_image = img[0];
        }
        if(num == 'cate_value_img')
        {
          _this.data[i].cate_value_img = img[0];
        }

      }, tit);
    },
    // 获取数据
    getAppraisalCateData() {
      this.fullscreenLoading = true
      appraisalCateDetailApi(this.$route.params.id)
        .then(res => {
          console.log(res.data)
          this.formValidate =  res.data
          this.data = res.data.cate_value
          this.fullscreenLoading = false
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.$message.error(res.message)
        })
    },
    // 提交
    handleSubmit() {
      if (!this.formValidate.cate_name) {
        this.$message.error('请填写品类名称')
        return false
      }
      this.formValidate.cate_value = this.data;
      this.formValidate.appraisal_cate_id = this.$route.params.id;
      saveAppraisalCateDataApi(this.formValidate)
        .then(res => {
          this.fullscreenLoading = false
          this.$message.success(res.message)
          this.$router.push({ path: this.roterPre + '/appraisal/cate' })
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.loading = false
          this.$message.error(res.message)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.label_tip{
  display: inline-block;
  margin-left: 20px;
  color: #C0C4CC;
}
.selWidth {
  width: 100%;
}
.selWidthd {
  width: 300px;
}
.dialog-scustom,.addDia{
  min-width: 400px;
  height: 900px;
  .el-dialog{
    width: 400px;
  }
  h3{
    color: #333;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    margin: 0;
  }
}
.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.agreement{
  width: 350px;
  margin: 0 auto;
  box-shadow: 1px 5px 5px 2px rgba(0,0,0,.2);
  padding: 26px;
  border-radius: 15px;
  .content{
    height: 600px;
    overflow-y:scroll;
    /deep/ p{
      font-size: 13px;
      line-height: 22px;
    }
  }
  /deep/ img{
    max-width: 100%;
  }
  p{
    text-align: justify;
  }
}
/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track{
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
  background-color: transparent;
  border-radius: 3px;
}
.iview-video-style {
  width: 40%;
  height: 180px;
  border-radius: 10px;
  background-color: #707070;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}
.iconv {
  color: #fff;
  line-height: 180px;
  display: inherit;
  font-size: 26px;
  position: absolute;
  top: -74px;
  left: 50%;
  margin-left: -25px;
}
.iview-video-style .mark {
  position: absolute;
  width: 100%;
  height: 30px;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
}
.uploadVideo {
  margin-left: 10px;
}
.perW50 {
  width: 50%;
}
.submission {
  margin-left: 10px;
}
.btndel {
  position: absolute;
  z-index: 1;
  width: 20px !important;
  height: 20px !important;
  left: 46px;
  top: -4px;
}

</style>
